import React from 'react';

export default function Feed({ user }) {
  const feedUrl = `${window.location.origin}/api/feed/${user?.dealer_id}`;
  const fbUrl = `${window.location.origin}/api/facebook/${user?.dealer_id}`;
  const fbCsvUrl = `${fbUrl}?format=csv`;

  const copy = (text) => { navigator.clipboard.writeText(text); alert('Copied!'); };

  const Box = ({ title, url, note }) => (
    <div style={{ background: '#111', border: '1px solid #333', borderRadius: 8, padding: 16, marginBottom: 16 }}>
      <div style={{ fontSize: 12, color: '#666', marginBottom: 8, textTransform: 'uppercase', letterSpacing: .5 }}>{title}</div>
      <code style={{ color: '#cc0000', fontSize: 13, wordBreak: 'break-all', fontFamily: 'monospace' }}>{url}</code>
      <br />
      <button onClick={() => copy(url)} style={{ padding: '6px 12px', background: '#222', border: '1px solid #333', borderRadius: 6, color: '#888', fontSize: 12, cursor: 'pointer', marginTop: 10 }}>Copy URL</button>
      {note && <div style={{ fontSize: 11, color: '#555', marginTop: 8 }}>{note}</div>}
    </div>
  );

  return (
    <div>
      <div className="page-header"><h1>Website <span>Feed</span></h1></div>
      <p style={{ color: '#888', marginBottom: 20, fontSize: 14 }}>Use these URLs to connect your inventory to websites, Facebook, and other platforms.</p>
      <Box title="Live Inventory Feed (JSON)" url={feedUrl} note="Use with All Import Pro or any website. Updates instantly." />
      <Box title="Facebook Marketplace Feed (JSON)" url={fbUrl} note="Only vehicles with a Facebook Price set will appear." />
      <Box title="Facebook Catalog (CSV)" url={fbCsvUrl} note="Upload directly to Facebook Commerce Manager." />
      <div style={{ background: '#111', border: '1px solid #333', borderRadius: 8, padding: 16 }}>
        <div style={{ fontSize: 12, color: '#666', marginBottom: 8, textTransform: 'uppercase', letterSpacing: .5 }}>Embed on Any Website</div>
        <code style={{ color: '#cc0000', fontSize: 13, fontFamily: 'monospace', whiteSpace: 'pre' }}>{`fetch('${feedUrl}')\n  .then(r => r.json())\n  .then(data => console.log(data.vehicles));`}</code>
        <br />
        <button onClick={() => copy(`fetch('${feedUrl}')\n  .then(r => r.json())\n  .then(data => console.log(data.vehicles));`)} style={{ padding: '6px 12px', background: '#222', border: '1px solid #333', borderRadius: 6, color: '#888', fontSize: 12, cursor: 'pointer', marginTop: 10 }}>Copy Code</button>
      </div>
    </div>
  );
}
